// FIXME: This file is just an example, please take it as reference to make your own.

import React from 'react'
import { Link as BaseLink } from 'react-router-dom'
import { Grid as BaseGrid, styled } from '@mui/material'
import { ArrowBack as BaseArrowBackIcon } from '@mui/icons-material'
import { Button as BaseButton } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  display: block;
  height: auto;
  position: relative;
  width: 100%;
`

export const Row = styled(({ margin, padding, ...props }) => <BaseGrid {...props} container />)`
  &.MuiGrid-container {
    margin: ${props => props.margin || 0};
    padding: ${props => props.padding || '30px 46px 70px 46px'};
    width: 100%;
    ${props => props.theme.breakpoints.down('lg')} {
      padding: ${props => props.padding || '57px 46px 30px'};
    }
    ${props => props.theme.breakpoints.down('md')} {
      padding: ${props => props.padding || '57px 18px 30px'};
    }
  }
`

export const Column = styled(({ margin, padding, ...props }) => <BaseGrid {...props} item />)`
  &.MuiGrid-item {
    margin: ${props => props.margin || 0};
    padding: ${props => props.padding || 0};
    width: 100%;
  }
`

export const Logo = styled(({ isDownToSmall, ...props }) => <img {...props} />)`
  height: ${props => (props.isDownToSmall ? '38px' : '52px')};
  pointer-events: none;
  user-select: none;
`

export const Link = styled(BaseLink)`
  margin: 0;
`

export const Text = styled('div')`
  color: ${props => props.theme.palette.brand.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 20px;
  font-weight: 500;

  ${props => props.theme.breakpoints.down('sm')} {
    margin: 10px 0;
  }
`

export const ArrowBackIcon = styled(BaseArrowBackIcon)`
  height: 24px;
  margin: 0 4px 0 0;
  width: 24px;

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const Button = styled(props => <BaseButton {...props} />)`
  text-wrap: nowrap;
  margin: 0 0 0 70px;
  ${props => props.theme.breakpoints.down('md')} {
    margin: 0 0 0 32px;
    max-width: 153px;
    max-height: 30px;
  }
`
